import { atom } from 'jotai';
import { pendingQueue } from 'shared/utils/pending-queue';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export const $ArticleGuessCardsWordsStore = atom<any>({});

export const $ArticleGuessCardsWords = safeAtomFamily((groupId: string) => {
  const a = atom(
    (get) => {
      const data = get($ArticleGuessCardsWordsStore)[groupId];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw new Promise((resolve) => pendingQueue.push(() => resolve('$ArticleGuessCardsWords placeholder')));
      }
      return data;
    },
    (get, set, newData) => {
      const old = get($ArticleGuessCardsWordsStore);
      set($ArticleGuessCardsWordsStore, { ...old, [groupId]: newData });
    },
  );

  a.debugLabel = `$ArticleGuessCardsWords+${encodeURIComponent(groupId)}`;

  return a;
});
